export enum OnboardingStep {
  WELCOME = 'welcome',
  IMPORT_EXISTING_WALLET = 'import_exiting',
  NEW_WALLET = 'new_wallet',
}
